module.exports = __webpack_public_path__ + "static/1-546b62962d5681d109819ce55a7034dc.png";